import { type PutExternalAddressByExternalAddressIdPayload, queryClient } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { putExternalAddress } from '../data-access/api';

type EditRecipientData = { id: string; payload: PutExternalAddressByExternalAddressIdPayload };

/**
 * @returns editRecipient mutation object
 */
export const useWalletWithdrawEditRecipientMutation = () =>
	useMutation({
		mutationFn: ({ id, payload }: EditRecipientData) => putExternalAddress(id, payload),
		onSuccess: data => {
			queryClient.invalidateQueries({ queryKey: ['recipients', 'cc2'] });
			queryClient.invalidateQueries({ queryKey: ['fetchExternalAddressById', data.data.id] });
		}
	});
